import axios from '@/plugins/axios';

export const getBackorders = async (
  userId,
  roles,
  office,
  axiosConfig = { noCancelRequest: true }
) => {
  const response = await axios.get(
    '/get-backorder-availability',
    {
      params: {
        user: userId,
        role: roles,
      },
    },
    axiosConfig
  );
  return response.data;
};

export const deleteBackorder = async (backorders) => {
  const deleteBackorderData = {
    selectedBackorders: backorders,
  };

  const response = await axios.post(
    '/delete-pending-orders',
    deleteBackorderData
  );
  return response.data;
};

export const generateOrder = async (backorders) => {
  const params = {
    orderLine: backorders,
  };

  const response = await axios.post('/generate-pending-orders', params);
  return response.data;
};
